"use client";

import { LoginForm } from "@/components/login-form";
import { useTranslations } from "next-intl";

export default function Page() {
  const t = useTranslations();

  return (
    <div className="relative flex min-h-svh w-full items-center justify-center overflow-hidden px-6 py-10 md:px-10">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,color-mix(in_oklab,var(--primary)_18%,transparent),transparent_30%),radial-gradient(circle_at_bottom_right,color-mix(in_oklab,var(--color-chart-2)_20%,transparent),transparent_35%)]" />
      <div className="relative grid w-full max-w-6xl gap-10 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
        <div className="hidden lg:block">
          <div className="space-y-6">
            <div className="inline-flex rounded-full border border-white/60 bg-background/80 px-4 py-2 text-sm font-medium text-muted-foreground shadow-sm">
              {t("auth.hero.badge")}
            </div>
            <div className="space-y-4">
              <p className="max-w-2xl text-4xl font-semibold tracking-tight text-balance xl:text-5xl">
                {t("auth.hero.title")}
              </p>
              <p className="max-w-xl text-base leading-7 text-muted-foreground xl:text-lg">
                {t("auth.hero.description")}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full max-w-md justify-self-center lg:justify-self-end">
          <LoginForm />
        </div>
      </div>
    </div>
  );
}
